module.exports = __webpack_public_path__ + "static/media/closeIcon.2b614362.svg";